import { Flex } from 'components/elements'
import { keyframes, styled } from 'theme'

export const shimmer = keyframes({
  '0%': {
    backgroundPosition: '-1000px 0px',
  },
  '100%': {
    backgroundPosition: '1000px 0px',
  },
})

export const TableList = styled(Flex, {
  borderTop: '1px solid $border',
})

export const ToggleCss = {
  borderRadius: '$size$10',
  width: 44,
  height: 24,
  mr: '$space$15',
}
export const IconCss = {
  width: 32,
  height: 40,
  mr: '$space$15',
}
export const TitleCss = {
  width: 90,
  height: 20,
}
export const DescriptionCss = {
  width: 120,
  height: 20,
}
export const SubTitleCss = {
  width: 250,
  height: 20,
}
export const Tags1Css = {
  width: 90,
  height: 26,
  borderRadius: '$size$4',
}
export const Tags2Css = {
  width: 110,
  height: 26,
  borderRadius: '$size$4',
}
export const TagsNumberCss = {
  borderRadius: '$size$4',
  width: 32,
  height: 26,
}
export const StatusCss = {
  borderRadius: '$size$10',
  width: 65,
  height: 20,
}
export const IconButtonCss = {
  width: 36,
  height: 36,
  borderRadius: '$size$4',
}
export const ImageCss = {
  width: 32,
  height: 32,
}
export const ShimmerCss = {
  animation: `${shimmer} 3s`,
  animationIterationCount: 'infinite',
  background: 'linear-gradient(to right, #e6e6e6 5%, #cccccc 25%, #e6e6e6 35%)',
  backgroundSize: '1000px 100%',
}
